document.addEventListener('DOMContentLoaded', function () {
  // 获取按钮元素
  var showTips = false
  var zkToggle = document.getElementById('zk-toggle');
  var zkTipsBox = document.getElementById('zk-tips-box');
 
  // 为按钮添加点击事件监听器
  zkToggle.addEventListener('click', function () {
    // console.log('点击了||', zkToggle.innerHTML);
    
    var zkToggleImg = document.getElementById('zk-toggle-img');
    
    if(!showTips) {
      // 展开
      zkTipsBox.classList.remove('zk-hide');
      zkToggleImg.src = 'https://cdn.shopify.com/s/files/1/0579/4365/4484/files/up.jpg?v=1724275018';
      showTips = true
      // zkToggle.innerHTML = "收起";
    } else {
      // 收起
      zkTipsBox.classList.add('zk-hide');
      zkToggleImg.src = 'https://cdn.shopify.com/s/files/1/0579/4365/4484/files/down.jpg?v=1724275017';
      showTips = false
      // zkToggle.innerHTML = "展开";
    }
  });
});